import HomeController, { HomeProps } from "../controller/home.controller";
import { GetServerSideProps, NextPage } from "next";
import React, { Suspense } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import Head from "next/head";
const MainSearchBox = dynamic(
  () => import("../components/Home/MainSearchBox"),
  {
    suspense: true,
  }
);
const Featured = dynamic(() => import("../components/Home/Featured"), {
  suspense: true,
});
const Section = dynamic(() => import("../components/Home/Section"));

const FeaturedArticles = dynamic(
  () => import("../components/Home/FeaturedArticles")
);

const Evaluation = dynamic(() => import("../components/Home/Evaluation"));
const Desc = dynamic(() => import("../components/Home/Desc"));

const Home: NextPage<HomeProps> = ({ featured, blogs }) => {
  return (
    <>
      <Head>
        <title>Bungalows for Sale in Ontario visit Bungalow Finder</title>

        <meta
          name="title"
          property="og:title"
          content="Bungalows for Sale in Ontario visit Bungalow Finder"
        />
        <meta
          name="description"
          property="og:description"
          content="how to find bungalows for sale in Canada? Bungalowfinder.ca is real estate website to discover modern bungalows, raised bungalows, at affordable prices. "
        />

        <meta
          name="keywords"
          content="Bungalows for sale, Bungalow Finder, Bungalow for sale,properties for sale,houses to rent,property for sale,link house for sale,new properties for sale,private property rentals,property for sale in canada,cottage house for sale,property for sale deals,bungalow for sale,detached house for sale,duplex house for sale,bungalows for sale,semi detached house for sale,houses for sale in toronto canada,house for rent in mississauga,mississauga rentals,Rentals in Mississauga,rental apartments in mississauga,realtors in mississauga,townhouse for rent mississauga,bungalows for rent in mississauga"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`https://bungalowfinder.ca`} />

        <meta
          property="og:image"
          content="https://bungalowfinder.ca/bungalow-color-logo.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="Bungalows for Sale in Ontario visit Bungalow Finder"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Bungalows for Sale in Ontario visit Bungalow Finder"
        />
        <meta
          name="twitter:description"
          content="Looking for a Bungalows for Sale in Canada"
        />
        <meta
          name="twitter:image"
          content="https://bungalowfinder.ca/images/ogimg.jpg"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@context": "https://schema.org/",
              "@type": "WebSite",
              "name": "Bungalow Finder",
              "url": "https://bungalowfinder.ca/",
              "sameAs": "https://bungalowfinder.ca/",
              "description": "Discover your dream bungalow home in Canada with BungalowFinder.ca. Explore our extensive listings and expert resources for a seamless house-hunting experience. Find the perfect single-story living space that suits your preferences and lifestyle. Start your bungalow journey today!",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://bungalowfinder.ca/city/{city}",
                "query-input": "name=city"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "itemReviewed": {
                  "@type": "LocalBusiness",
                  "name": "Bungalow Finder",
                  "address": "33 Pearl Street, Mississauga, On L5M1X1",
                  "image": "https://bungalowfinder.ca/_next/image?url=%2Fbanner.jpeg&w=3840&q=75",
                  "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.9",
                    "ratingCount": "5"
                  }
                },
                "ratingValue": "4.9",
                "ratingCount": "5"
              },
              "sourceOrganization": {
                "@type": "Organization",
                "name": "Bungalow Finder"
              }
            }`,
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@context": "https://schema.org/",
              "@type": "ItemList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/",
                   "name": "Home"
                   },
                  "url": "https://bungalowfinder.ca/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Toronto",
                   "name": "Bungalow for sale in Toronto"
                   },
                  "url": "https://bungalowfinder.ca/city/Toronto"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Mississauga",
                   "name": "BBungalow for sale in Mississauga"
                   },
                  "url": "https://bungalowfinder.ca/city/Mississauga"
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Oakville",
                   "name": "BBungalow for sale in Oakville"
                   },
                  "url": "https://bungalowfinder.ca/city/Oakville"
                },
                {
                  "@type": "ListItem",
                  "position": 5,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Milton",
                   "name": "BBungalow for sale in Milton"
                   },
                  "url": "https://bungalowfinder.ca/city/Milton"
                },
                {
                  "@type": "ListItem",
                  "position": 6,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Burlington",
                   "name": "BBungalow for sale in Burlington"
                   },
                  "url": "https://bungalowfinder.ca/city/Burlington"
                },
                {
                  "@type": "ListItem",
                  "position": 7,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/city/Brampton",
                   "name": "BBungalow for sale in Bramtpon"
                   },
                  "url": "https://bungalowfinder.ca/city/Brampton"
                },
                {
                  "@type": "ListItem",
                  "position":8,
                  "item":
                  {
                   "@id": "https://bungalowfinder.ca/blogs",
                   "name": "BBungalow Finder Real Estate Blog"
                   },
                  "url": "https://bungalowfinder.ca/blogs"
                }]}`,
          }}
        ></script>
      </Head>
      <div className="md:h-[75vh] h-[50vh] relative flex z-30 justify-center items-end pb-14 md:items-center md:pb-0">
        <Image
          className="absolute -z-50 scale-100"
          src="/banner.jpeg"
          priority
          placeholder="blur"
          blurDataURL="data:image/webp;base64,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"
          alt="Banner"
          layout="fill"
          objectFit="cover"
        />

        <div className="flex flex-col justify-center items-center w-full md:w-1/2 z-50 px-3 container">
          <h1
            style={{ textShadow: "0 0 1rem #000" }}
            className="text-white text-lg md:text-3xl pb-5 font-medium text-center"
          >
            Discover Bungalows For Sale
          </h1>
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            <MainSearchBox />
          </Suspense>
        </div>
      </div>
      <Suspense
        fallback={
          <>
            <p>Loading...</p>
          </>
        }
      >
        <Featured properties={featured} />
      </Suspense>
      <Evaluation />

      <Section />

      <FeaturedArticles articles={blogs} />

      <Desc />
    </>
  );
};

export default Home;

export const getServerSideProps: GetServerSideProps = async () => {
  return await HomeController();
};
